<template>
  <div
    class="xl:pr-40 lg:pr-32 md:pr-20 md:pl-10 pl-5 sticky top-16 bg-background py-4 z-10 w-full"
  >
    <div class="md:flex justify-between items-center">
     
      <h1 class="mb-3 flex md:mb-0 text-xl font-bold text-foreground">
      <button class="font-bold mr-3 items-center flex text-xl md:mb-0 align-center bg-hover text-foreground">
        <ion-icon v-if="memePackOpen()" @click="exitMemePack" name="arrow-back-outline"></ion-icon>
      </button>
        {{ this.$store.state.activeLink }}
      <h4 class="mb-3 flex md:mb-0 text-xl font-bold text-foreground">
      </h4>
      </h1>
     
      <div>
        <IdButton />
      </div>
    </div>
  </div>
  <div
    v-if="memePreviews && memePreviews.length"
    class="xl:pr-40 lg:pr-32 md:pr-20 md:pl-10 px-3 py-4"
  >
    <div class="grid place-items-center">
      <div
        class="grid xl:grid-cols-4 lg:grid-cols-3 grid-cols-2 gap-2 sm:gap-6"
      >
        <div
          class="xl:col-span-4 lg:col-span-3 col-span-2 flex justify-between flex-wrap gap-y-4"
        ></div>
        <MemeTile
          v-for="(meme, index) in memePreviews"
          :key="meme.id"
          :meme="meme"
          :index="index"
          @selectPack="selectPack"
        ></MemeTile>
      </div>
    </div>
  </div>
  <div class="text-center" v-else>There were no results.</div>
</template>
<script>
import MemeTile from "../discover/MemeTile.vue";
import IdButton from "../discover/IdButton.vue";

export default {
  components: {
    MemeTile,
    IdButton,
  },
  created() {
    // localStorage.setItem("preferredId", this.number);

    // Check localstorage for preferredId

    let prefferedId = localStorage.getItem("preferredId");
    if (prefferedId) {
      this.$store.dispatch("GetMemePreviews", prefferedId);
      this.$store.dispatch("GetFeaturedMemes", prefferedId);
    } else {
      this.$store.dispatch("GetMemePreviews", 6024);
      this.$store.dispatch("GetFeaturedMemes", 6024);
    }
  },
  computed: {
    memePreviews() {
      let memePrevs = this.$store.state.memePreviews;
      let featuredMemes = this.$store.state.featuredMemes;
      let memeChildren = this.$store.state.memeChildren;
      console.log(this.$store.state.activeLink)
      if (this.$store.state.activeLink === "Featured" && featuredMemes) {
        console.log("featured memes")
        return featuredMemes;
      }
      if (this.$store.state.activeLink === "Search" && memePrevs) {
        const query = this.$store.state.searchMessage.toLowerCase();

        const filtered = memePrevs.filter((item) => {
          const display_name = item["display_name"].toLowerCase();
          const author = item["author"].toLowerCase();

          if (display_name.includes(query) || author.includes(query)) {
            return true;
          }
          return false;
        });
        return filtered;
      }
      console.log(memePrevs)
      if(this.$store.state.activeLink !== "Browse" && memeChildren) {
        console.log("meme children")
        return memeChildren;
      }
      return this.$store.state.memePreviews;
    },
  },
  methods: {
    shuffleMemes() {
      this.$store.dispatch("ShuffleMemes");
      this.updateChoice("Shuffle");
    },
    updateChoice(choice) {
      this.sortChoice = choice;
    },
    memePackOpen(){
      if(this.$store.state.memeChildren) {
        return true;
      }
    },
    selectPack(pack) {
      console.log(pack)
      // Change this.$store.state.memePreviews to the pack
      // Change active link to be the pack name
      this.$store.dispatch("ChangeActiveLink", `Pack of ${pack[0].display_name}`);
      this.$store.commit("SetMemeChildren", pack)
    },
    exitMemePack(){
      this.$store.dispatch("ChangeActiveLink", "Browse");
      this.$store.commit("SetMemeChildren", null)
    }
  },
  props: {
    mode: String,
  },
};
</script>
